import React, { Component } from 'react';
import { connectRange } from 'react-instantsearch/connectors';
import { Range } from 'rc-slider';
import {
  RailStyle,
  TrackStyle,
  HandleStyle,
  RangeClassName,
  SliderHeading,
  FilterHeading,
  FilterRow,
  SliderWrapper,
  FilterSection,
} from './style';

// TODO: where to put those?
const RangeSlider = ({
  min,
  max,
  lowerBound,
  upperBound,
  handleChange,
  handleAfterChange,
  disabled,
}) => {
  return (
    <Range
      className={RangeClassName}
      railStyle={RailStyle}
      handleStyle={[HandleStyle, HandleStyle]}
      trackStyle={[TrackStyle(disabled), TrackStyle(disabled)]}
      min={min}
      max={max}
      value={[lowerBound, upperBound]}
      defaultValue={[0, 100]}
      onChange={handleChange}
      onAfterChange={handleAfterChange}
      allowCross={false}
      disabled={disabled}
    />
  );
};

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lowerBound: 0,
      upperBound: 100,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.canRefine) {
      this.setState({
        lowerBound: nextProps.currentRefinement.min,
        upperBound: nextProps.currentRefinement.max,
      });
    }
  }

  handleAfterChange = ([lowerBound, upperBound]) => {
    const { canRefine, currentRefinement, refine } = this.props;
    if (
      canRefine &&
      (lowerBound !== currentRefinement.min ||
        upperBound !== currentRefinement.max)
    ) {
      refine({
        min: lowerBound,
        max: upperBound,
      });
    }
  };

  handleChange = ([lowerBound, upperBound]) => {
    this.setState({
      lowerBound,
      upperBound,
    });
  };

  render() {
    let { canRefine, min, max, label, unit, hide } = this.props;
    const { lowerBound, upperBound } = this.state;

    if (!hide) hide = false;
    return (
      <FilterSection hide={hide}>
        <SliderHeading>
          <FilterHeading>{label}</FilterHeading>
          <span>
            {lowerBound} {unit} - {upperBound} {unit}
          </span>
        </SliderHeading>
        <FilterRow
          css={`
            padding-bottom: 0;
          `}
        >
          <SliderWrapper>
            <RangeSlider
              min={min}
              max={max}
              lowerBound={lowerBound}
              upperBound={upperBound}
              handleChange={this.handleChange}
              handleAfterChange={this.handleAfterChange}
              disabled={!canRefine}
            />
          </SliderWrapper>
        </FilterRow>
      </FilterSection>
    );
  }
}

const connectedSlider = connectRange(Slider);
export default connectedSlider;



// WEBPACK FOOTER //
// ./src/components/filter/filterSlider.js